export default "__VITE_ASSET__DqM7Y2of__"